import { Suspense, lazy } from 'react';

import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';

import { Toaster } from '@storeblocks/toast';

import { CenteredLoadingIndicator, ErrorBoundary } from '@storebrand-digital/bank-foundation-components';

import { UpdateCustomerAccountProvider } from '@components/UpdateCustomerAccountContext';

import Guards from './components/Guards';
import Protected from './components/Protected';
import {
  loggedInPageWithUidRouteObjects,
  loggedInPageWithoutUidRouteObjects,
  openPageWithProductRouteObjects,
} from './routerPathsAndElements';

const DevPanel = lazy(() => import('./components/Devpanel'));

const ErrorPage = lazy(() => import('./features/ErrorPage'));

export default function OnboardingRouter() {
  return (
    <BrowserRouter basename="/bank/kunde">
      <ErrorBoundary errorView={<ErrorPage />}>
        <Suspense fallback={<CenteredLoadingIndicator isFixed />}>
          <Routes>
            <Route
              element={
                <Guards>
                  <Outlet />
                </Guards>
              }
            >
              {openPageWithProductRouteObjects}
              <Route
                element={
                  <Protected>
                    <Outlet />
                  </Protected>
                }
              >
                {loggedInPageWithoutUidRouteObjects}
                <Route
                  element={
                    <UpdateCustomerAccountProvider>
                      <ErrorBoundary errorView={null}>
                        <DevPanel />
                      </ErrorBoundary>
                      <Outlet />
                    </UpdateCustomerAccountProvider>
                  }
                >
                  {loggedInPageWithUidRouteObjects}
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
        <Toaster />
      </ErrorBoundary>
    </BrowserRouter>
  );
}
